import { createApi } from '@reduxjs/toolkit/query/react';

import iqBaseQuery from './iqBaseQuery';
import { CacheTag } from '../CacheTag';

export const baseCacheTimeInSeconds = 30;

const iqApi = createApi({
  reducerPath: 'iqApi',
  baseQuery: iqBaseQuery,
  endpoints: () => ({}),
  keepUnusedDataFor:
    process?.env?.NODE_ENV === 'test' ? 0 : baseCacheTimeInSeconds,
  tagTypes: [CacheTag.ProviderAssignmentRecommendations],
});

export default iqApi;
